(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function findProductForm() {
    var forms = Array.prototype.slice.call(
      document.querySelectorAll('form[action*="/cart/add"], form[action*="cart/add"]')
    );
    if (!forms.length) return null;

    var withSubmit = null;
    for (var i = 0; i < forms.length; i++) {
      if (
        forms[i].querySelector(
          'button[type="submit"], input[type="submit"], button[name="add"], [data-add-to-cart]'
        )
      ) {
        withSubmit = forms[i];
        break;
      }
    }
    return withSubmit || forms[0];
  }

  function getVariantIdFromURL() {
    var v = new URLSearchParams(window.location.search).get('variant');
    var n = Number(v);
    return isFinite(n) ? n : null;
  }

  function safeJsonParse(text) {
    try {
      return JSON.parse(text);
    } catch (e) {
      return null;
    }
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .split('&').join('&amp;')
      .split('<').join('&lt;')
      .split('>').join('&gt;')
      .split('"').join('&quot;')
      .split("'").join('&#039;');
  }

  function init() {
    var box = document.querySelector('[data-compatible-chains]');
    if (!box) return false;

    if (box.dataset.compatChainsInit === 'true') return true;
    box.dataset.compatChainsInit = 'true';

    var listEl = box.querySelector('[data-compatible-chains-list]');
    var payloadEl = box.querySelector('[data-compatible-chains-payload]');
    if (!listEl || !payloadEl) return false;

    var payload = null;
    try {
      payload = JSON.parse(payloadEl.textContent);
    } catch (e) {
      box.style.display = 'none';
      return false;
    }

    var productForm = findProductForm();
    if (!productForm) {
      box.style.display = 'none';
      return false;
    }

    function getVariantIdFromForm() {
      var idEl = productForm.querySelector('[name="id"]');
      if (!idEl) return null;
      var n = Number(idEl.value);
      return isFinite(n) ? n : null;
    }

    function getSelectedVariantId() {
      return getVariantIdFromForm() || getVariantIdFromURL() || payload.currentVariantId || null;
    }

    function pickListForVariant(variantId) {
      var vList = [];
      var pList = payload.productCompat || [];

      if (payload.byVariant && payload.byVariant[String(variantId)]) {
        vList = payload.byVariant[String(variantId)] || [];
      }

      if (Array.isArray(vList) && vList.length) return vList;
      if (Array.isArray(pList)) return pList;
      return [];
    }

    function getCheckedChainVariantIds() {
      var currentBox = document.querySelector('[data-compatible-chains]');
      if (!currentBox) return [];
      var checked = Array.prototype.slice.call(
        currentBox.querySelectorAll('.compatible-chains__checkbox:checked')
      );
      var ids = [];
      for (var i = 0; i < checked.length; i++) {
        var n = Number(checked[i].dataset.chainVariantId);
        if (isFinite(n) && n > 0) ids.push(n);
      }
      return ids;
    }

    function render(variantId) {
      var maxToShow = Number(payload.maxToShow || 3);
      var list = pickListForVariant(variantId).slice(0, maxToShow);

      if (!list.length) {
        box.style.display = 'none';
        listEl.innerHTML = '';
        return;
      }

      box.style.display = '';

      var rows = '';
      for (var i = 0; i < list.length; i++) {
        var item = list[i];
        var img = item.image
          ? '<img src="' +
            escapeHtml(item.image) +
            '" alt="" style="width:66px;height:66px;object-fit:contain;">'
          : '';

        var sku = item.sku ? ' (' + item.sku + ')' : '';
        var price = item.price ? String(item.price) : '';
        var borderTop = i === 0 ? 'none' : '1px solid rgba(0,0,0,.08)';

        var titleHtml = item.url
          ? '<a href="' +
            escapeHtml(item.url) +
            '" target="_blank" rel="noopener noreferrer" style="text-decoration:underline;">' +
            escapeHtml(item.title || 'Unknown') +
            '</a>'
          : escapeHtml(item.title || 'Unknown');

        rows +=
          '<label style="display:inline-flex;gap:.75rem;align-items:center;border-top:' +
          borderTop +
          ';">' +
          '<input type="checkbox" class="compatible-chains__checkbox" data-chain-variant-id="' +
          escapeHtml(item.variantId) +
          '" style="transform:scale(1.1);">' +
          img +
          '<div style="display:flex;flex-direction:column;gap:.15rem;">' +
          '<div style="font-weight:600;line-height:1.2;">' +
          titleHtml +
          escapeHtml(sku) +
          '</div>' +
          '<div style="font-size:13px; opacity:.85;">' +
          escapeHtml(price) +
          '</div>' +
          '</div>' +
          '</label>';
      }

      listEl.innerHTML = '<div>' + rows + '</div>';
    }

    var initialVariantId = getSelectedVariantId();
    if (!initialVariantId) {
      box.style.display = 'none';
      return false;
    }
    render(Number(initialVariantId));

    var last = String(initialVariantId);
    if (box._compatChainsTimer) clearInterval(box._compatChainsTimer);
    box._compatChainsTimer = setInterval(function () {
      var nowId = getSelectedVariantId();
      var now = String(nowId || '');
      if (now && now !== last) {
        last = now;
        render(Number(now));
      }
    }, 250);

    window.__compatChains = window.__compatChains || {};
    window.__compatChains.getAddonItems = function (mainVariantId) {
      var ids = getCheckedChainVariantIds();
      if (!ids.length) return [];
      var items = [];
      for (var i = 0; i < ids.length; i++) {
        items.push({
          id: ids[i],
          quantity: 1,
          properties: {
            _addon_source: 'chainsaw_checkbox',
            _addon_for_variant: String(mainVariantId)
          }
        });
      }
      return items;
    };

    return true;
  }

  function wrapFetchOnce() {
  if (window.__compatChainsFetchWrapped) return;
  window.__compatChainsFetchWrapped = true;

  var originalFetch = window.fetch;

  function getSignature(mainVariantId) {
    try {
      var box = document.querySelector('[data-compatible-chains]');
      if (!box) return String(mainVariantId) + '|none';
      var cbs = Array.prototype.slice.call(
        box.querySelectorAll('.compatible-chains__checkbox:checked')
      );
      var ids = [];
      for (var i = 0; i < cbs.length; i++) {
        var n = Number(cbs[i].dataset.chainVariantId);
        if (isFinite(n) && n > 0) ids.push(n);
      }
      ids.sort(function (a, b) { return a - b; });
      return String(mainVariantId) + '|' + ids.join(',');
    } catch (e) {
      return String(mainVariantId) + '|err';
    }
  }

  window.__compatChainsLastAdd = window.__compatChainsLastAdd || { sig: '', ts: 0 };

  window.fetch = function (input, init) {
    return originalFetch.apply(this, arguments).then(function (res) {
      try {
        var url = '';
        if (typeof input === 'string') url = input;
        else if (input && input.url) url = input.url;

        var isAdd =
          typeof url === 'string' &&
          (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/add.js') !== -1);

        var headers = init && init.headers ? init.headers : null;
        var marked = false;

        if (headers) {
          if (typeof headers.get === 'function') marked = headers.get('X-Compat-Chains') === '1';
          else marked = headers['X-Compat-Chains'] === '1' || headers['x-compat-chains'] === '1';
        }

        if (
          isAdd &&
          !marked &&
          res &&
          res.ok &&
          window.__compatChains &&
          typeof window.__compatChains.getAddonItems === 'function'
        ) {
          var clone = res.clone();
          clone
            .text()
            .then(function (text) {
              var data = safeJsonParse(text);
              var mainVariantId =
                (data && data.id && Number(data.id)) ||
                (data && data.items && data.items[0] && Number(data.items[0].id)) ||
                null;

              if (!mainVariantId) return;

              var addonItems = window.__compatChains.getAddonItems(mainVariantId);
              if (!addonItems || !addonItems.length) return;

              // ---- de-dupe lock (4s) ----
              var sig = getSignature(mainVariantId);
              var now = Date.now();
              if (
                window.__compatChainsLastAdd.sig === sig &&
                (now - window.__compatChainsLastAdd.ts) < 4000
              ) {
                return;
              }
              window.__compatChainsLastAdd.sig = sig;
              window.__compatChainsLastAdd.ts = now;

              originalFetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Compat-Chains': '1' },
                body: JSON.stringify({ items: addonItems })
              })
                .then(function () {
                  // Uncheck after adding so popups/second add-to-cart calls won't re-add
                  try {
                    var box = document.querySelector('[data-compatible-chains]');
                    if (!box) return;
                    var checked = box.querySelectorAll('.compatible-chains__checkbox:checked');
                    for (var i = 0; i < checked.length; i++) checked[i].checked = false;
                  } catch (e) {}
                })
                ['catch'](function () {});
            })
            ['catch'](function () {});
        }
      } catch (e) {}

      return res;
    });
  };
}


  function runAll() {
    init();
    wrapFetchOnce();
  }

  ready(runAll);

  document.addEventListener('shopify:section:load', runAll);
  document.addEventListener('shopify:section:reorder', runAll);
  document.addEventListener('shopify:section:select', runAll);

  var mo = new MutationObserver(function () {
    var box = document.querySelector('[data-compatible-chains]');
    if (box && box.dataset.compatChainsInit !== 'true') runAll();
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();